import TripleDot from './TripleDot.view';

export default TripleDot;
